import { NAME } from './constants';

export const HIDE_ALERT = `${NAME}/HIDE_ALERT`;
export const IS_DISABLED = `${NAME}/IS_DISABLED`;
export const RESET_ALERT = `${NAME}/RESET_ALERT`;
export const SHOW_ALERT = `${NAME}/SHOW_ALERT`;
